import { apiGet } from '../standardApi';

export const apiRepayments = async (
  cgrmContractingCode,
  clientType,
  startDate,
  endDate,
  skip,
  limit,
  carteTpCheck
) => {
  let params = `?CgrmContractingCode=${cgrmContractingCode}&ClientType=${clientType}&StartDate=${startDate}&EndDate=${endDate}&WithTp=${carteTpCheck}`;
  if (skip) {
    params += `&Skip=${skip}`;
  }
  if (limit) {
    params += `&Top=${limit}`;
  }
  const response = await apiGet('/Repayments' + params);
  return response;
};
export const apiRepaymentsDocument = async (
  cgrmContractingCode,
  clientType,
  startDate,
  endDate,
  skip,
  limit,
  carteTpCheck,
  fileNumber
) => {
  let params = `?ClientType=${clientType}&StartDate=${startDate}&EndDate=${endDate}&WithTp=${carteTpCheck}`;
  if (skip) {
    params += `&Skip=${skip}`;
  }
  if (limit) {
    params += `&Top=${limit}`;
  }
  if (fileNumber != null) {
    params += `&NumeroFichier=${fileNumber}`;
  }
  const response = await apiGet(
    '/Repayments/GetClientRepaymentDocument' + params
  );
  return response;
};

export const apiConsumtions = async (
  cgrmContractingCode,
  requestType,
  startDate,
  endDate,
  skip,
  limit
) => {
  let params = `?CgrmContractingCode=${cgrmContractingCode}&RequestType=${requestType}&StartDate=${startDate}&EndDate=${endDate}`;
  if (skip) {
    params += `&Skip=${skip}`;
  }
  if (limit) {
    params += `&Top=${limit}`;
  }
  const response = await apiGet('/Consumptions' + params);
  return response;
};
